import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageLIGAF6 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Aitana Bonmatí Wins Third Straight Flashscore Award",
            author: "footballgirl",
                 date: "March 5, 2026",
            image: "images/ligaf/6a.jpg",
         content: `<p>Aitana Bonmatí was 
         crowned Player of the Year at the 
         2025 Flashscore Awards for the third
          consecutive time, recognizing her
           outstanding contributions to Barcelona 
           and Spain. Her stellar year included key 
           goals and assists in domestic and 
           international competitions. This award
            underscores her status as one of the world'
          top players.</p>`,
            tags: [ "Aitana Bonmatí", "Spain", 
                "Estadi Olímpic Lluís Companys",
                 "Liga F", "El Clásico",
                  "award", "Barcelona" ],
           navIndices: { prev: 'ligaf-5', next: 'ligaf-7' }
        });
    }

    init() {
        console.log('ArticlePageLIGAF6 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Liga F
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'ligaf' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_ligaf.png';
            leagueLogo.alt = 'Liga F';
        }
    }
}